export const retentionDuration = 864000000; // 10 days
const retentionTimestampKey = 'retention-timestamp';
export const retentionFields = [
    'VehicleRegistrationNumber',
    'VehicleBrandModel',
    'taxation',
    'tradeInValue',
    'Name',
    'EmailAddress',
    'PhoneNumber',
    'City',
    'PostalCode',
    'Street',
    'FirstName',
    'LastName',
    'Mileage',
    'Gender',
    'Initials',
    'Tussenvoegsel',
    'HouseNumber',
    'HouseNumberAddition',
    'VideoCallRequested',
    'image-taxation-0',
    'image-taxation-1',
    'image-taxation-2',
    'image-taxation-3',
    'image-taxation-4',
    'image-vehicleDetails'
];

/**
 * Save item in localStorage
 * @param {string} key
 * @param {*} val
 * @param {boolean} saveAsJSON
 * @returns {string || null}
 */
export function setStorage(key, val, saveAsJSON = true) {
    updateRetentionTime();
    if (saveAsJSON) {
        val = JSON.stringify(val);
    }
    try {
        const savedStorage = localStorage.setItem(key, val);
        return savedStorage;
    } catch (e) {
        if (e.code === 22) {
            console.error('Localstorage is full');
        }
        return false;
    }
}

/**
 * Get item from localStorage
 * check if retention has been passed
 * update retention timestamp
 * @param {string} key
 * @param {boolean} getAsJSON
 * @returns {string || null}
 */
export function getStorage(key, getAsJSON = true) {
    checkStorageRetentionTime();
    updateRetentionTime();
    let data = localStorage.getItem(key) || null;

    if (getAsJSON && data) {
        data = JSON.parse(data);
    }

    return data || null;
}

/**
 * Remove item from storage
 * @param {string} key
 */
export function removeStorage(key) {
    updateRetentionTime();
    localStorage.removeItem(key);
}

/**
 * Save new current timestamp
 */
export function updateRetentionTime() {
    localStorage.setItem(retentionTimestampKey, Date.now());
}

/**
 * Check if retention has been passed
 * if so delete all retentionFields in localStorage
 */
export function checkStorageRetentionTime() {
    const currentTime = Date.now();
    const lastSaveTimestamp = localStorage.getItem(retentionTimestampKey);
    if (!lastSaveTimestamp) {
        updateRetentionTime();
        return;
    }

    const maxRetentionTime = +lastSaveTimestamp + retentionDuration;

    if (maxRetentionTime < currentTime) {
        retentionFields.forEach(key => removeStorage(key));
    }

    updateRetentionTime();
}
